import { CheckCircle2, CalendarClock, AlertCircle, AlertTriangle, XCircle, MinusCircle, CircleDashed, Clock } from "lucide-react";

// Automatic contract urgency status (separate from manual renewal stages).
export const CONTRACT_STATUS = {
  "Active": { cls: "bg-[#9ACC32]/15 text-[#4A700A]", icon: CheckCircle2 },
  "Renewal Upcoming": { cls: "bg-sky-100 text-sky-700", icon: CalendarClock },
  "Renewal Due": { cls: "bg-amber-100 text-amber-800", icon: Clock },
  "Follow-Up Required": { cls: "bg-orange-200 text-orange-900", icon: AlertCircle },
  "Urgent Follow-Up": { cls: "bg-red-100 text-red-700", icon: AlertTriangle },
  "Expired": { cls: "bg-red-600 text-white", icon: XCircle },
  "Cancelled": { cls: "bg-slate-200 text-slate-600", icon: MinusCircle },
  "Former Advertiser": { cls: "bg-slate-200 text-slate-600", icon: MinusCircle },
  "No Contract": { cls: "bg-slate-100 text-slate-500", icon: CircleDashed },
};
export const STATUS_FILTERS = ["Active", "Renewal Upcoming", "Renewal Due", "Follow-Up Required", "Urgent Follow-Up", "Expired", "Cancelled", "Former Advertiser", "No Contract"];

export const FILE_CATEGORIES = [
  { key: "contracts", label: "01 – Contracts", hint: "Signed contracts, renewal agreements, amendments" },
  { key: "billing", label: "02 – Payment & Billing", hint: "Payment/company information form, billing authorization, payment schedule" },
  { key: "company", label: "03 – Company Information", hint: "Sales/customer forms, business info, logos, photos, brand guidelines" },
  { key: "print_ads", label: "04 – Print Advertisements", hint: "Original artwork, current, previous and revised ads" },
  { key: "website", label: "05 – Website Profile", hint: "Description, photos, logo, highlights, contact info, profile content" },
  { key: "coupons", label: "06 – Coupons & Promotions", hint: "Coupon artwork, offer details, start/end dates" },
  { key: "proofs", label: "07 – Proofs & Approvals", hint: "Ad proofs, approval confirmations, revised and final artwork" },
  { key: "misc", label: "08 – Correspondence / Misc.", hint: "Relevant supporting information" },
];

export const WEBSITE_STATUSES = ["Not Started", "In Progress", "Live", "Needs Update", "Not Included"];
export const COUPON_STATUSES = ["None", "Planned", "Active", "Expired"];
export const PRICING_STATUSES = ["Founding", "Regular"];
